import * as types from "../_constants";
const initialState = {
  breadcrumb: [],
}
export const breadcrumbReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BREADCRUMB:
      return { ...state, breadcrumb: action.payload };
      case types.SET_BREADCRUMB_SEARCH:
      return { ...state, breadcrumbSearch: action.payload };
    default:
      return state;
  }
};
